import styled, { css } from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'
import Box from 'components/shared/Box'
import { colorNames } from 'styles/theme'

interface WrapperProps {
    isEdited?: boolean
    shouldKeepBorderInDarkMode?: boolean
}

export const Wrapper = styled(Box)<WrapperProps>`
    border: 2px solid ${({ theme }) => theme.colors.grayscale_300};
    border-radius: 6px;
    transition: background-color 200ms ease-in;

    ${({ isEdited }) =>
        isEdited &&
        css`
            background-color: ${({ theme }) => theme.colors.grayscale_100};
        `}

    @media ${respondAbove.xl} {
        border-radius: 8px;
        min-height: 86px;
    }

    ${({ theme, shouldKeepBorderInDarkMode }) => {
        const isDarkMode = theme.mode === 'dark'
        if (isDarkMode)
            return css`
                background-color: ${theme.colors.grayscale_100} !important;
                border-color: ${shouldKeepBorderInDarkMode
                    ? colorNames.grayscale_200
                    : theme.colors.grayscale_100} !important;

                @media ${respondAbove.xl} {
                    border-color: ${theme.colors.grayscale_100} !important;
                }
            `
    }}
`
